import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/siteData";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 sm:py-28 lg:py-32 bg-white brand-glow"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span
            data-testid="services-eyebrow"
            className="inline-block text-green-700 font-semibold text-sm uppercase tracking-widest"
          >
            What we do
          </span>
          <h2
            data-testid="services-headline"
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Specialist exterior cleaning, done properly.
          </h2>
          <p className="mt-5 text-base lg:text-lg text-slate-600 leading-relaxed">
            From block paving to solar panels — one local team, the right kit, and a
            finish you&apos;ll actually notice.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            const isImageCard = Boolean(s.image);
            return (
              <a
                key={s.id}
                href="#contact"
                data-testid={`service-card-${s.id}`}
                className="service-card group block rounded-2xl border border-slate-100 bg-white overflow-hidden shadow-sm"
              >
                <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
                  {isImageCard ? (
                    <img
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <div className="relative w-full h-full bg-gradient-to-br from-blue-700 via-blue-800 to-slate-900 flex items-center justify-center overflow-hidden">
                      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 30% 30%, rgba(34,197,94,0.6), transparent 60%), radial-gradient(circle at 75% 70%, rgba(59,130,246,0.4), transparent 55%)" }} />
                      <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "linear-gradient(135deg, transparent 0%, transparent 49%, rgba(255,255,255,0.08) 50%, transparent 51%, transparent 100%)", backgroundSize: "14px 14px" }} />
                      <Icon className="w-20 h-20 text-white drop-shadow-lg transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
                      <span className="absolute bottom-3 left-4 text-[10px] uppercase tracking-[0.25em] text-green-300 font-bold">
                        Specialist Service
                      </span>
                    </div>
                  )}
                  <div className="absolute top-3 left-3 inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/90 backdrop-blur text-blue-700 shadow">
                    <Icon className="w-4 h-4" />
                  </div>
                  <div className="absolute top-3 right-3 inline-flex items-center justify-center w-9 h-9 rounded-full bg-green-600 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </div>
                <div className="p-5">
                  <div className="text-xs text-slate-400 font-mono mb-1">
                    {String(idx + 1).padStart(2, "0")}
                  </div>
                  <h3
                    className="text-lg font-bold text-slate-900 leading-snug"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {s.description}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
